import React from 'react';

const SortCriteriaCompact = ({ sortCriteria }) => {
  const selectedOption =
    sortCriteria && (sortCriteria.find((sort) => sort.selected === true) || {});
  const value = (selectedOption && selectedOption.value) || '';
  return (
    <label className="custom-select px-6 py-3 border border-border-secondary rounded-radius flex justify-between items-center gap-2 text-text-tertiary focus-within:outline-blue-500 focus-within:outline-2 min-w-[220px] relative">
      <select
        value={value}
        className="appearance-none bg-transparent p-0 w-auto border-none min-h-auto outline-0 absolute inset-0 opacity-0"
        onChange={(event) => (window.location = event.target.value)}
      >
        {sortCriteria &&
          sortCriteria.map(({ text, value, selected }, index) => (
            <option value={value} key={`sorteriaCompact-${index}`}>
              {text}
            </option>
          ))}
      </select>
      <span className="flex-1">
        {selectedOption?.text || (sortCriteria?.[0]?.text || '')}
      </span>
      <span className="icon icon-outlined text-text-tertiary">keyboard_arrow_down</span>
    </label>
  );
};

export default SortCriteriaCompact;
